import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../../constants/providers/AuthProvider';
import { NotificationProvider, useNotificationCenter } from '../../context/NotificationContext';
import { NotificationCenter } from '../notifications/NotificationCenter';
import { TopBarV2 } from './TopBarV2';
import { StudentSidebar } from './StudentSidebar';
import { PageLayout } from './PageLayout';

const SIDEBAR_STORAGE_KEY = 'rollops-student-sidebar-open';

function AuthenticatedLayoutStudentContent({ children }: { children: React.ReactNode }) {
  const { loading: authLoading } = useAuth();
  const { isOpen: isNotificationOpen, closeNotificationCenter } = useNotificationCenter();

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEY);
    return stored === 'true';
  });

  const toggleSidebar = () => {
    setSidebarOpen((prev) => {
      const next = !prev;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(next));
      }
      return next;
    });
  };

  if (authLoading) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#111010] text-[#EBFFEE] font-['Inter']">
      <TopBarV2 />

      <StudentSidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

      <div className="flex-1 flex min-h-0 pt-16">
        <div className="flex-1 min-w-0 min-h-0 flex flex-col pb-16 md:pb-0 ml-0 md:ml-20 px-4 sm:px-5 md:px-6 lg:px-8">
          <main className="flex-1 flex flex-col min-h-0 overflow-auto w-full min-w-0">
            <PageLayout maxWidth="full" padding="none">
              {children}
            </PageLayout>
          </main>
        </div>
      </div>

      <NotificationCenter
        isOpen={isNotificationOpen}
        onClose={closeNotificationCenter}
      />
    </div>
  );
}

export function AuthenticatedLayoutStudent() {
  const { session } = useAuth();

  if (!session) {
    return <Navigate to="/signin" replace />;
  }

  return (
    <NotificationProvider>
      <AuthenticatedLayoutStudentContent>
        <Outlet />
      </AuthenticatedLayoutStudentContent>
    </NotificationProvider>
  );
}
